import React, { Component } from 'react'
import { getASwitchingFromChamp } from '../../utils/confrontationsFunctions'

/* Components */
import ConfrontationView from './ConfrontationView'

class Confrontation extends Component {

    constructor(props) {
        super(props)
        this.state = {
            champObject: '',
            champId: null,

            firstLoad: props.firstLoad,
            switchingList: [],
            switchingId: props.switchingId,
            isScoreMan: true,

            arrayOfCompetitors: [],

            studentSexo: '',
            studentFaixa: '',
            studentPeso: '',
            studentIdade: '',
            roundOf32Competitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
            roundOf16Competitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
            quarterFinalsCompetitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
            semiFinalsCompetitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
            finalCompetitors: [{ nome: '' }, { nome: '' }],

            stepIndex: 0,
            contentOfConfrontation: '',

            arrayOfTeamsWithScore: [],

            widthOfFases: '25%',
            showRoundOf32: false,

            pageToGo: '',

            loadingConfrontations: false,

            snackbarChamp: false,
            snackbarChampMsg: ''
        }
    }

    componentDidMount = () => {
        this.setState({
            champObject: this.props.champObject,
            champId: this.props.champId,
            switchingId: this.props.switchingId,
            isScoreMan: this.props.isScoreMan
        })
        this.renderConfrontation(this.props.switchingId, this.props.champId)
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            champObject: nextProps.champObject,
            champId: nextProps.champId,
            switchingId: nextProps.switchingId,
            isScoreMan: nextProps.isScoreMan
        })
        this.renderConfrontation(nextProps.switchingId, nextProps.champId)
    }

    renderConfrontation = async (id, key) => {
        this.setState({ loadingConfrontations: true })

        /* Create array of switching list */
        let localArrayOfswitching = []
        for (let i = 0; i < 10; i++) {
            localArrayOfswitching.push(i)
        }

        /* Create empty confrontations */
        this.setState({
            switchingList: localArrayOfswitching,
            roundOf32Competitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
            roundOf16Competitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
            quarterFinalsCompetitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
            semiFinalsCompetitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
            finalCompetitors: [{ nome: '' }, { nome: '' }]
        })

        /* Get all confrontations */
        if (id && key) {
            const switching = await getASwitchingFromChamp(key, id);
            if (switching) {

                // Set general infos
                this.setState({
                    studentSexo: switching.sexo,
                    studentFaixa: switching.faixa,
                    studentPeso: switching.peso,
                    studentIdade: switching.idade,
                })

                // Get round of 32
                if (switching.roundOf32) {
                    let roundOf32Competitors = [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }]
                    for (let i = 0; i < switching.roundOf32.length; i++) {
                        roundOf32Competitors[i] = switching.roundOf32[i]
                    }
                    this.setState({
                        roundOf32Competitors: roundOf32Competitors,
                        widthOfFases: '20%',
                        showRoundOf32: true
                    })
                }

                // Get round of 16
                if (switching.roundOf16) {
                    let roundOf16Competitors = [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }]
                    for (let i = 0; i < switching.roundOf16.length; i++) {
                        roundOf16Competitors[i] = switching.roundOf16[i]
                    }
                    this.setState({ roundOf16Competitors: roundOf16Competitors })
                }

                // Get quarter finals
                if (switching.quarterFinals) {
                    let quarterFinalsCompetitors = [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }]
                    for (let i = 0; i < switching.quarterFinals.length; i++) {
                        quarterFinalsCompetitors[i] = switching.quarterFinals[i]
                    }
                    this.setState({ quarterFinalsCompetitors: quarterFinalsCompetitors })
                }

                // Get semi finals
                if (switching.semiFinals) {
                    let semiFinalsCompetitors = [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }]
                    for (let i = 0; i < switching.semiFinals.length; i++) {
                        semiFinalsCompetitors[i] = switching.semiFinals[i]
                    }
                    this.setState({ semiFinalsCompetitors: semiFinalsCompetitors })
                }

                // Get final
                if (switching.final) {
                    let finalCompetitors = [{ nome: '' }, { nome: '' }]
                    for (let i = 0; i < switching.final.length; i++) {
                        finalCompetitors[i] = switching.final[i]
                    }
                    this.setState({ finalCompetitors: finalCompetitors })
                }

                // Get array of Teams
                if (switching.arrayOfTeams)
                    this.setState({ arrayOfTeamsWithScore: switching.arrayOfTeams })

            }

            this.setState({ loadingConfrontations: false });
        } else { this.setState({ loadingConfrontations: false }) }
    }

    /**
     * Methods to go forward or backward in the stages
     */
    goToStage = (stage) => {
        /* Hide all blocks */
        if (document.getElementById('roundOf32BlockMenu') && document.getElementById('roundOf32Block'))
            document.getElementById('roundOf32Block').style.display = 'none'

        document.getElementById('roundOf32Block').style.display = 'none'
        document.getElementById('roundOf16Block').style.display = 'none'
        document.getElementById('quarterFinalsBlock').style.display = 'none'
        document.getElementById('semiFinalsBlock').style.display = 'none'
        document.getElementById('finalBlock').style.display = 'none'

        /* Show the right block */
        document.getElementById(stage).style.display = 'block'
    }

    render() {
        return (
            <ConfrontationView
                champObject={this.state.champObject}
                champId={this.state.champId}
                switchingId={this.state.switchingId}
                isScoreMan={this.state.isScoreMan}
                roundOf32Competitors={this.state.roundOf32Competitors}
                roundOf16Competitors={this.state.roundOf16Competitors}
                quarterFinalsCompetitors={this.state.quarterFinalsCompetitors}
                semiFinalsCompetitors={this.state.semiFinalsCompetitors}
                finalCompetitors={this.state.finalCompetitors}
                loadingConfrontations={this.state.loadingConfrontations}
                studentSexo={this.state.studentSexo}
                studentPeso={this.state.studentPeso}
                studentIdade={this.state.studentIdade}
                showRoundOf32={this.state.showRoundOf32}

                goToStage={e => this.goToStage(e)}
            />
        )
    }

}

export default Confrontation